import _ from "lodash";

const mapParams = params => {
  let mapFns = [];
  let keysParams = _.keys(params);
  keysParams.forEach(keyParam => {
    let param = params[keyParam].default ? params[keyParam].default : params[keyParam];
    let keys = _.keys(param);
    keys.forEach(key => {
      mapFns.push({
        name: key,
        fn: param[key],
        keyParam: keyParam
      });
    });
  });
  return mapFns;
};

const mapSelectors = params => {
  return state => {
    let mapReturn = {};

    mapParams(params).forEach(item => {
      if (!mapReturn[item.keyParam]) {
        mapReturn[item.keyParam] = {};
      }
      mapReturn[item.keyParam][
        [`${item.name}`]
      ] = item.fn(state);
    });
    return mapReturn;
  };
};

const mapActions = params => {
  return dispatch => {
    let mapReturn = {};

    mapParams(params).forEach(item => {
      if (!mapReturn[item.keyParam]) {
        mapReturn[item.keyParam] = {};
      }
      mapReturn[item.keyParam][
        [`${item.name}`]
      ] = (...parameters) => dispatch(item.fn(...parameters));
    });
    return mapReturn;
  };
};

export {
  mapSelectors,
  mapActions
};
